export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11021.2d1b1a59.jpg";